const translations = {
  en: {
    common: {
      cancel: "Cancel",
      save: "Save",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      search: "Search",
    },
    header: {
      brand: "OMEGA SMART SYSTEMS",
      language: "Language",
      switchToLight: "Switch to light mode",
      switchToDark: "Switch to dark mode",
      hello: "Hello {{username}}",
      logout: "Logout",
      login: "Login",
      changePassword: "Change Password",
      changeWinboxPassword: "Change OSS Winbox Password",
      enterNewPassword: "Enter your new password:",
      enterWinboxDetails:
        "Enter the details to change the OSS Winbox password:",
      newPassword: "New Password",
      passwordMinimum:
        "Password must be at least 8 characters long.",
      passwordRules:
        "Password must contain at least one uppercase letter, one number, and one special character.",
    },
  },
  ar: {
    common: {
      cancel: "إلغاء",
      save: "حفظ",
      add: "إضافة",
      edit: "تعديل",
      delete: "حذف",
      search: "بحث",
    },
    header: {
      brand: "أوميغا سمارت سيستمز",
      language: "اللغة",
      switchToLight: "التبديل إلى الوضع الفاتح",
      switchToDark: "التبديل إلى الوضع الداكن",
      hello: "مرحباً {{username}}",
      logout: "تسجيل الخروج",
      login: "تسجيل الدخول",
      changePassword: "تغيير كلمة المرور",
      changeWinboxPassword:
        "تغيير كلمة مرور OSS Winbox",
      enterNewPassword:
        "أدخل كلمة المرور الجديدة:",
      enterWinboxDetails:
        "أدخل المعلومات اللازمة لتغيير كلمة مرور OSS Winbox:",
      newPassword: "كلمة المرور الجديدة",
      passwordMinimum:
        "يجب ألا تقل كلمة المرور عن 8 أحرف.",
      passwordRules:
        "يجب أن تحتوي كلمة المرور على حرف إنجليزي كبير واحد ورقم واحد ورمز خاص واحد على الأقل.",
    },
  },
};

translations.en.collection = {
  drawerExchange: "Drawer Exchange",
  pocketExchange: "Pocket Exchange",
  resellerPayment: "Reseller Payment",
  payment: "Payment",
  monthlyReport: "Monthly Report",
  balanceUsd: "Balance USD",
  balanceLbp: "Balance LBP",
  dailyDrawerExchange: "Daily Drawer Exchange",
  exchange: "Exchange",
  pocketMoneyExchange: "Pocket Money Exchange",
  resellerCollect: "Reseller Collect",
  actions: "Actions",
  wallet: "Wallet",
  notes: "Notes",
  statement: "Statement",
  discount: "Discount",
  offer: "Offer",
  fullName: "Full Name",
  phoneNumber: "Phone Number",
  clientNotes: "Client Notes",
  discounts: "Discounts",
  paymentNotes: "Payment Notes",
  villageName: "Village Name",
  address: "Address",
  balance: "Balance",
  collector: "Collector",
  columns: "Columns",
  filter: "Filter",
  export: "Export",
  exportCsv: "Download as CSV",
  print: "Print",
  excel: "Excel",
  searchPlaceholder: "Search...",
  addNotes: "Add Notes",
  statementOfAccount: "Statement Of Account",
  receipt: "Receipt",
  addOffer: "Add Offer",
  filters: "Filters",
  filterBy: "Filter by {{column}}",
  close: "Close",
  rowsPerPage: "Rows per page:",
  selectedRows: "Selected rows: {{count}}",
  pageRange: "{{from}}–{{to}} of {{count}}",
  collectionSheet: "Collection",
  collectionFile: "Collection.xlsx",
};

translations.ar.collection = {
  drawerExchange: "تحويل الصندوق",
  pocketExchange: "تحويل الجيب",
  resellerPayment: "دفعة الموزّع",
  payment: "دفعة",
  monthlyReport: "التقرير الشهري",
  balanceUsd: "رصيد الدولار",
  balanceLbp: "رصيد الليرة اللبنانية",
  dailyDrawerExchange: "تحويل الصندوق اليومي",
  exchange: "تحويل",
  pocketMoneyExchange: "تحويل أموال الجيب",
  resellerCollect: "تحصيل من الموزّع",
  actions: "الإجراءات",
  wallet: "المحفظة",
  notes: "الملاحظات",
  statement: "كشف الحساب",
  discount: "خصم",
  offer: "عرض",
  fullName: "الاسم الكامل",
  phoneNumber: "رقم الهاتف",
  clientNotes: "ملاحظات العميل",
  discounts: "الخصومات",
  paymentNotes: "ملاحظات الدفع",
  villageName: "اسم البلدة",
  address: "العنوان",
  balance: "الرصيد",
  collector: "المحصّل",
  columns: "الأعمدة",
  filter: "تصفية",
  export: "تصدير",
  exportCsv: "تنزيل بصيغة CSV",
  print: "طباعة",
  excel: "إكسل",
  searchPlaceholder: "بحث...",
  addNotes: "إضافة ملاحظات",
  statementOfAccount: "كشف الحساب",
  receipt: "إيصال",
  addOffer: "إضافة عرض",
  filters: "عوامل التصفية",
  filterBy: "تصفية حسب {{column}}",
  close: "إغلاق",
  rowsPerPage: "عدد الصفوف في الصفحة:",
  selectedRows: "الصفوف المحددة: {{count}}",
  pageRange: "{{from}}–{{to}} من {{count}}",
  collectionSheet: "التحصيل",
  collectionFile: "التحصيل.xlsx",
};

translations.en.payments = {
  title: "Payments",
  newPayment: "Payment",
  formTitle: "Payment Form",
  accountHolder: "Account Holder",
  chooseAccountHolder: "Choose Account Holder",
  warehouse: "Warehouse",
  chooseWarehouse: "Choose Warehouse",
  accountHolderRequired: "Account Holder is required.",
  supplier: "Supplier",
  chooseSupplier: "Choose Supplier",
  category: "Category",
  chooseCategory: "Choose Category",
  exchangeRate: "Exchange Rate",
  paidUsd: "Paid in USD",
  paidLbp: "Paid in LBP",
  returnedLbp: "Returned in LBP",
  description: "Description",
  submit: "Submit",
  expense: "Expenses",
  loan: "Loan",
  paymentId: "Payment ID",
  date: "Date",
  type: "Type",
  createdBy: "Created By",
  drawer: "Drawer",
  status: "Status",
  search: "Search...",
};

translations.ar.payments = {
  title: "الدفعات",
  newPayment: "دفعة",
  formTitle: "نموذج الدفعة",
  accountHolder: "صاحب الحساب",
  chooseAccountHolder: "اختر صاحب الحساب",
  warehouse: "المستودع",
  chooseWarehouse: "اختر المستودع",
  accountHolderRequired: "صاحب الحساب مطلوب.",
  supplier: "المورّد",
  chooseSupplier: "اختر المورّد",
  category: "الفئة",
  chooseCategory: "اختر الفئة",
  exchangeRate: "سعر الصرف",
  paidUsd: "المدفوع بالدولار",
  paidLbp: "المدفوع بالليرة اللبنانية",
  returnedLbp: "المُعاد بالليرة اللبنانية",
  description: "الوصف",
  submit: "إرسال",
  expense: "مصاريف",
  loan: "قرض",
  paymentId: "رقم الدفعة",
  date: "التاريخ",
  type: "النوع",
  createdBy: "أنشأها",
  drawer: "الصندوق",
  status: "الحالة",
  search: "بحث...",
};

translations.en.sidebar = {
  dashboard: "Dashboard",
  clients: "Clients",
  resellers: "Resellers",
  testingResellers: "Testing Resellers",
  testingClients: "Testing Package",
  internetPlans: "Internet Plans",
  internet: "Internet",
  oss: "OSS",
  idm: "IDM",
  cable: "Cable",
  iptv: "IPTV",
  account: "Account",
  accounts: "Accounts",
  subscriptions: "Subscriptions",
  issues: "Issues",
  offers: "Offers",
  labels: "Labels",
  accounting: "Accounting",
  collection: "Collection",
  collectors: "My Collection",
  accountingLog: "Accounting Log",
  payments: "Payments",
  onlinePayments: "Online Payments",
  orders: "Orders",
  resellerOrders: "Reseller Orders",
  invoices: "Invoices",
  systemInvoices: "Sys Invoices",
  receipts: "Receipts",
  shiftReceipts: "Shift Receipts",
  subServices: "Sub Services",
  inventory: "Inventory",
  fiberCores: "Fiber Cores",
  wirelessAccessPoints: "Wireless Access Points",
  reporting: "Reporting",
  onboarding: "Onboarding",
  mobile: "Mobile",
  requests: "Requests",
  actionLog: "Action Log",
  addOssWinboxUser: "Add OSS Winbox User",
  startShift: "Start Shift",
  endShift: "End Shift",
};

translations.ar.sidebar = {
  dashboard: "لوحة التحكم",
  clients: "العملاء",
  resellers: "الموزّعون",
  testingResellers: "الموزّعون التجريبيون",
  testingClients: "الباقة التجريبية",
  internetPlans: "باقات الإنترنت",
  internet: "الإنترنت",
  oss: "أو إس إس",
  idm: "آي دي إم",
  cable: "الكابل",
  iptv: "آي بي تي في",
  account: "الحساب",
  accounts: "الحسابات",
  subscriptions: "الاشتراكات",
  issues: "المشكلات",
  offers: "العروض",
  labels: "التصنيفات",
  accounting: "المحاسبة",
  collection: "التحصيل",
  collectors: "تحصيلي",
  accountingLog: "سجل المحاسبة",
  payments: "الدفعات",
  onlinePayments: "الدفعات الإلكترونية",
  orders: "الطلبات",
  resellerOrders: "طلبات الموزّعين",
  invoices: "الفواتير",
  systemInvoices: "فواتير النظام",
  receipts: "الإيصالات",
  shiftReceipts: "إيصالات الوردية",
  subServices: "الخدمات الفرعية",
  inventory: "المخزون",
  fiberCores: "أنوية الألياف الضوئية",
  wirelessAccessPoints: "نقاط الوصول اللاسلكية",
  reporting: "التقارير",
  onboarding: "تهيئة العملاء",
  mobile: "الهاتف المحمول",
  requests: "الطلبات",
  actionLog: "سجل الإجراءات",
  addOssWinboxUser: "إضافة مستخدم OSS Winbox",
  startShift: "بدء الوردية",
  endShift: "إنهاء الوردية",
};

/* ARABIC_WALLET_AND_RESELLER_ORDERS */
Object.assign(translations.en.sidebar, {
  details: "Details",
  addOrder: "Add Order",
  siteOrders: "Site Orders",
  quotations: "Quotations",
});

Object.assign(translations.ar.sidebar, {
  details: "التفاصيل",
  addOrder: "إضافة طلب",
  siteOrders: "طلبات المواقع",
  quotations: "عروض الأسعار",
});

Object.assign(translations.en.collection, {
  walletOperation: "Wallet operation",
  walletClient: "Client:",
  walletSettlement: "Settlement",
  walletDeposit: "Deposit",
  walletSettlementHelp: "Select the payable invoice and record its settlement.",
  walletNoOutstanding: "There are no outstanding invoices to settle.",
  walletDepositHelp: "Add money to the client's Wallet credit.",
  walletSettleBeforeCredit: "Outstanding invoices must be settled before adding Wallet credit.",
  walletLoadingDetails: "Loading Wallet details...",
  walletBalanceUnavailable: "The client balance is unavailable.",
  walletCurrentCredit: "Current Wallet Credit:",
  walletTotalDue: "Total Amount Due:",
  walletUnavailable: "Unavailable",
  walletLoading: "Loading...",
  walletEnterExchangeRate: "Enter a valid exchange rate",
  walletInvalidAmount: "Invalid amount",
  walletSelectOutstanding: "Select an outstanding invoice",
  walletDetailsStillLoading: "The Wallet details are still loading.",
  walletSettlementRequiresBalance: "Settlement requires a positive outstanding balance.",
  walletSelectPayable: "Select at least one payable outstanding item.",
  walletSecureOperationUnsupported: "This browser cannot create a secure operation ID.",
  walletLoadFailed: "Unable to load the Wallet details.",
  walletOperationFailed: "Unable to complete the Wallet operation.",
  walletAutomaticallyApplied: "Wallet automatically applied: -${{amount}}",
  walletOutstandingInvoices: "Outstanding Invoices",
  walletSelectAll: "Select All",
  walletSelectedTotal: "Selected Total",
  walletTotalOutstanding: "Total Outstanding",
  walletPaymentTotal: "Payment",
  walletDiscountTotal: "Discount",
  walletAppliedSelected: "Applied to Selected",
  walletAppliedOther: "Applied to Other Outstanding",
  walletTotalRemaining: "Total Remaining",
  walletCreditAdded: "Wallet Deposit / Credit",
  walletPartialPayment: "Partial payment - the remaining amount stays outstanding and Wallet credit is $0.",
  walletLegacyOutstanding: "Legacy outstanding balance",
  walletInvoiceNumber: "Invoice #{{id}}",
  freeCollection: "Free Collection",
  freeCollectionConfirm: "Send a free collection request for invoice #{{id}}?",
  freeCollectionPending: "Free collection requested, waiting for approval",
  freeCollectionRefused: "Free collection refused",
  freeCollectionFailed: "Could not send the free collection request.",
  freeCollectionCancel: "Cancel",
  freeCollectionSend: "Send request",
  walletDate: "Date:",
  walletNoDescription: "No description",
  walletOriginalAmount: "Original: $",
  walletInvoiceDiscount: "Invoice discount: $",
  walletReceiptsApplied: "Wallet receipts applied: $",
  walletSettleEarlier: "Settle the earlier item first.",
  walletDepositUsd: "Deposit Amount in USD:",
  walletPaymentUsd: "Payment Amount in USD:",
  walletChangeUsd: "Change Returned in USD:",
  walletDiscountUsd: "Discount in USD:",
  walletExchangeRate: "Exchange Rate:",
  walletDepositLbp: "Deposit Amount in LBP:",
  walletPaymentLbp: "Payment Amount in LBP:",
  walletChangeLbp: "Change Returned in LBP:",
  walletDiscountLbp: "Discount in LBP:",
  walletReason: "Reason:",
  walletAnotherPaymentMethod: "Another Payment Method:",
  onlineDrawer: "Online Drawer",
  onlinePaymentsTitle: "Online Payments",
  onlineBalanceUsd: "Online Drawer USD:",
  onlineBalanceLbp: "Online Drawer LBP:",
  onlineCashOut: "Cash Out",
  onlineCashOutTitle: "Cash Out Online Funds",
  onlinePaymentMethod: "Payment Method:",
  onlineSelectMethod: "Select Whish or OMT",
  onlineCurrency: "Currency:",
  onlineAmount: "Amount:",
  onlineFee: "Fee:",
  onlineReason: "Reason:",
  onlineTotalDeduction: "Total deducted from Online Drawer:",
  onlineNoShift: "You can view the Online Drawer, but an active shift is required to cash out.",
  onlineDate: "Date",
  onlineType: "Type",
  onlineMethod: "Method",
  onlineClient: "Client",
  onlineAmountUsd: "Amount USD",
  onlineAmountLbp: "Amount LBP",
  onlineFeeUsd: "Fee USD",
  onlineFeeLbp: "Fee LBP",
  onlineChangeUsd: "Change USD",
  onlineChangeLbp: "Change LBP",
  onlineAfterUsd: "Balance After USD",
  onlineAfterLbp: "Balance After LBP",
  onlineInitiator: "Initiator",
  onlineDestination: "Destination Drawer",
  onlineReceipt: "Receipt ID",
  onlineInvoice: "Invoice ID",
  onlineDescription: "Description",
  onlineCollectionType: "Collection",
  onlineCashOutType: "Cash Out",
  onlineReversalType: "Reversal",
  onlineSubmit: "Cash Out",
  onlineCancel: "Cancel",
  onlineSubmitting: "Processing...",
  onlineCashOutSuccess: "Cash-out completed successfully.",
  onlineLoadError: "Unable to load the Online Drawer.",
  onlineCashOutError: "Unable to process the cash-out.",
  onlineCashOutPayments: "Cash Out / Payments",
  onlinePaymentTab: "Payment",
  onlinePaymentTitle: "Pay From Online Funds",
  onlinePaymentType: "Payment",
  onlinePaymentSubmit: "Pay",
  onlinePaymentSuccess: "Payment recorded successfully.",
  onlinePaymentError: "Unable to process the payment.",
  onlineNoRows: "No Online Drawer transactions yet.",
  walletCreditAfterDeposit: "Wallet Credit After Deposit:",
  walletRemainingAfterSettlement: "Invoice Remaining After Settlement:",
  walletExtraCashAdded: "Extra cash of ${{amount}} will be added as Wallet credit.",
  walletExtraCashBlocked: "Extra cash cannot become Wallet credit while another outstanding item remains.",
  walletSubmitting: "Submitting...",
  walletSettleSelected: "Settle Selected Invoice",
  walletAddCredit: "Add Wallet Credit",
  walletHide: "Hide",
  walletCheckShield: "Check MC Shield",
});

Object.assign(translations.ar.collection, {
  walletOperation: "عملية المحفظة",
  walletClient: "العميل:",
  walletSettlement: "تسديد",
  walletDeposit: "إيداع",
  walletSettlementHelp: "اختر الفاتورة المستحقة وسجّل تسديدها.",
  walletNoOutstanding: "لا توجد فواتير مستحقة للتسديد.",
  walletDepositHelp: "أضف رصيداً إلى محفظة العميل.",
  walletSettleBeforeCredit: "يجب تسديد الفواتير المستحقة قبل إضافة رصيد إلى المحفظة.",
  walletLoadingDetails: "جارٍ تحميل تفاصيل المحفظة...",
  walletBalanceUnavailable: "رصيد العميل غير متاح.",
  walletCurrentCredit: "الرصيد الحالي للمحفظة:",
  walletTotalDue: "إجمالي المبلغ المستحق:",
  walletUnavailable: "غير متاح",
  walletLoading: "جارٍ التحميل...",
  walletEnterExchangeRate: "أدخل سعر صرف صالحاً",
  walletInvalidAmount: "مبلغ غير صالح",
  walletSelectOutstanding: "اختر فاتورة مستحقة",
  walletDetailsStillLoading: "ما زال تحميل تفاصيل المحفظة جارياً.",
  walletSettlementRequiresBalance: "يتطلب التسديد وجود رصيد مستحق أكبر من صفر.",
  walletSelectPayable: "اختر بندًا مستحقًا واحدًا على الأقل للتسديد.",
  walletSecureOperationUnsupported: "لا يستطيع هذا المتصفح إنشاء معرّف آمن للعملية.",
  walletLoadFailed: "تعذّر تحميل تفاصيل المحفظة.",
  walletOperationFailed: "تعذّر إكمال عملية المحفظة.",
  walletAutomaticallyApplied: "تم تطبيق رصيد المحفظة تلقائياً: -${{amount}}",
  walletOutstandingInvoices: "الفواتير المستحقة",
  walletSelectAll: "تحديد الكل",
  walletSelectedTotal: "إجمالي المحدد",
  walletTotalOutstanding: "إجمالي المستحق",
  walletPaymentTotal: "الدفعة",
  walletDiscountTotal: "الخصم",
  walletAppliedSelected: "المطبق على المحدد",
  walletAppliedOther: "المطبق على المستحقات الأخرى",
  walletTotalRemaining: "إجمالي المتبقي",
  walletCreditAdded: "إيداع / رصيد المحفظة",
  walletPartialPayment: "دفعة جزئية - يبقى المبلغ المتبقي مستحقًا ويكون رصيد المحفظة $0.",
  walletLegacyOutstanding: "رصيد مستحق سابق",
  walletInvoiceNumber: "الفاتورة رقم {{id}}",
  freeCollection: "تحصيل مجاني",
  freeCollectionConfirm: "إرسال طلب تحصيل مجاني للفاتورة رقم {{id}}؟",
  freeCollectionPending: "تم طلب التحصيل المجاني، بانتظار الموافقة",
  freeCollectionRefused: "تم رفض التحصيل المجاني",
  freeCollectionFailed: "تعذّر إرسال طلب التحصيل المجاني.",
  freeCollectionCancel: "إلغاء",
  freeCollectionSend: "إرسال الطلب",
  walletDate: "التاريخ:",
  walletNoDescription: "لا يوجد وصف",
  walletOriginalAmount: "المبلغ الأصلي: $",
  walletInvoiceDiscount: "خصم الفاتورة: $",
  walletReceiptsApplied: "إيصالات المحفظة المطبّقة: $",
  walletSettleEarlier: "سدّد البند السابق أولاً.",
  walletDepositUsd: "مبلغ الإيداع بالدولار:",
  walletPaymentUsd: "مبلغ الدفع بالدولار:",
  walletChangeUsd: "المبلغ المُعاد بالدولار:",
  walletDiscountUsd: "الخصم بالدولار:",
  walletExchangeRate: "سعر الصرف:",
  walletDepositLbp: "مبلغ الإيداع بالليرة اللبنانية:",
  walletPaymentLbp: "مبلغ الدفع بالليرة اللبنانية:",
  walletChangeLbp: "المبلغ المُعاد بالليرة اللبنانية:",
  walletDiscountLbp: "الخصم بالليرة اللبنانية:",
  walletReason: "السبب:",
  walletAnotherPaymentMethod: "طريقة دفع أخرى:",
  onlineDrawer: "الدرج الإلكتروني",
  onlinePaymentsTitle: "الدفعات الإلكترونية",
  onlineBalanceUsd: "رصيد الدرج الإلكتروني بالدولار:",
  onlineBalanceLbp: "رصيد الدرج الإلكتروني بالليرة:",
  onlineCashOut: "سحب نقدي",
  onlineCashOutTitle: "سحب أموال الدرج الإلكتروني",
  onlinePaymentMethod: "طريقة الدفع:",
  onlineSelectMethod: "اختر Whish أو OMT",
  onlineCurrency: "العملة:",
  onlineAmount: "المبلغ:",
  onlineFee: "الرسوم:",
  onlineReason: "السبب:",
  onlineTotalDeduction: "إجمالي المبلغ المخصوم من الدرج الإلكتروني:",
  onlineNoShift: "يمكنك عرض الدرج الإلكتروني، لكن يجب أن تكون لديك وردية نشطة لإجراء سحب نقدي.",
  onlineDate: "التاريخ",
  onlineType: "النوع",
  onlineMethod: "الطريقة",
  onlineClient: "العميل",
  onlineAmountUsd: "المبلغ بالدولار",
  onlineAmountLbp: "المبلغ بالليرة",
  onlineFeeUsd: "الرسوم بالدولار",
  onlineFeeLbp: "الرسوم بالليرة",
  onlineChangeUsd: "التغيير بالدولار",
  onlineChangeLbp: "التغيير بالليرة",
  onlineAfterUsd: "الرصيد بعد العملية بالدولار",
  onlineAfterLbp: "الرصيد بعد العملية بالليرة",
  onlineInitiator: "منفذ العملية",
  onlineDestination: "الدرج المستلم",
  onlineReceipt: "رقم الإيصال",
  onlineInvoice: "رقم الفاتورة",
  onlineDescription: "الوصف",
  onlineCollectionType: "تحصيل",
  onlineCashOutType: "سحب نقدي",
  onlineReversalType: "عكس العملية",
  onlineSubmit: "سحب نقدي",
  onlineCancel: "إلغاء",
  onlineSubmitting: "جارٍ التنفيذ...",
  onlineCashOutSuccess: "تم السحب النقدي بنجاح.",
  onlineLoadError: "تعذر تحميل الدرج الإلكتروني.",
  onlineCashOutError: "تعذر تنفيذ السحب النقدي.",
  onlineCashOutPayments: "سحب نقدي / دفعات",
  onlinePaymentTab: "دفعة",
  onlinePaymentTitle: "الدفع من الأموال الإلكترونية",
  onlinePaymentType: "دفعة",
  onlinePaymentSubmit: "دفع",
  onlinePaymentSuccess: "تم تسجيل الدفعة بنجاح.",
  onlinePaymentError: "تعذر تنفيذ الدفعة.",
  onlineNoRows: "لا توجد عمليات في الدرج الإلكتروني بعد.",
  walletCreditAfterDeposit: "رصيد المحفظة بعد الإيداع:",
  walletRemainingAfterSettlement: "المبلغ المتبقي على الفاتورة بعد التسديد:",
  walletExtraCashAdded: "سيُضاف المبلغ النقدي الإضافي وقدره ${{amount}} إلى رصيد المحفظة.",
  walletExtraCashBlocked: "لا يمكن تحويل المبلغ النقدي الإضافي إلى رصيد في المحفظة ما دام هناك بند مستحق آخر.",
  walletSubmitting: "جارٍ الإرسال...",
  walletSettleSelected: "تسديد الفاتورة المحددة",
  walletAddCredit: "إضافة رصيد إلى المحفظة",
  walletHide: "إخفاء",
  walletCheckShield: "فحص MC Shield",
});

Object.assign(translations.en.collection, {
  receiptDate: "Date:",
  receiptFullName: "Full Name:",
  receiptBalanceUsd: "Balance (USD):",
  receiptPaidAmountUsd: "Paid Amount (USD):",
  receiptPaidAmountLbp: "Paid Amount (LBP):",
  receiptPaidUsd: "Paid (USD):",
  receiptPaidLbp: "Paid (LBP):",
  receiptExchangeRate: "Exchange Rate:",
  receiptRemaining: "Remaining:",
  receiptRemainingAmount: "Remaining Amount:",
  receiptDiscountUsd: "Discount (USD):",
  receiptDiscountLbp: "Discount (LBP):",
  receiptThankYou: "Thank you for your payment.",
  receiptPrintButton: "Print Receipt",
  receiptAm: "AM",
  receiptPm: "PM",
});

Object.assign(translations.ar.collection, {
  receiptDate: "التاريخ:",
  receiptFullName: "الاسم الكامل:",
  receiptBalanceUsd: "الرصيد بالدولار:",
  receiptPaidAmountUsd: "المبلغ المدفوع بالدولار:",
  receiptPaidAmountLbp: "المبلغ المدفوع بالليرة اللبنانية:",
  receiptPaidUsd: "المدفوع بالدولار:",
  receiptPaidLbp: "المدفوع بالليرة اللبنانية:",
  receiptExchangeRate: "سعر الصرف:",
  receiptRemaining: "المتبقي:",
  receiptRemainingAmount: "المبلغ المتبقي:",
  receiptDiscountUsd: "الخصم بالدولار:",
  receiptDiscountLbp: "الخصم بالليرة اللبنانية:",
  receiptThankYou: "شكرًا لتسديدكم.",
  receiptPrintButton: "طباعة الإيصال",
  receiptAm: "ص",
  receiptPm: "م",
});

translations.en.resellerOrders = {
  selectDealer: "Select Dealer:",
  chooseDealer: "Choose Dealer",
  orderDate: "Order Date:",
  productName: "Product Name",
  serviceName: "Service Name",
  quantity: "Quantity",
  quantityLabel: "Quantity:",
  retailPrice: "Retail Price",
  sellingPrice: "Selling Price",
  totalPrice: "Total Price",
  action: "Action",
  actions: "Actions",
  delete: "Delete",
  addProduct: "Add Product",
  addService: "Add Service",
  totalAmount: "Total Amount:",
  submitOrder: "Submit Order",
  addProductTitle: "Add Product",
  chooseProduct: "Choose Product",
  addServiceTitle: "Add Service",
  chooseService: "Choose Service",
  price: "Price:",
  cancel: "Cancel",
  add: "Add",
  orderSuccessful: "Order successful!",
  orderFailed: "Order failed!",
  invoiceId: "Invoice ID",
  name: "Name",
  date: "Date",
  show: "Show",
  searchPlaceholder: "Search...",
  invoiceDetails: "Invoice Details",
  close: "Close",
  invoiceDetailsFor: "Invoice Details for {{id}}",
  itemType: "Item Type",
  itemName: "Item Name",
  product: "Product",
  service: "Service",
  totalProductPrice: "Total Product Price:",
  totalServicePrice: "Total Service Price:",
  totalPriceLabel: "Total Price:",
  detailsFetchError: "Failed to fetch invoice details. Please try again later.",
  columns: "Columns",
  filters: "Filters",
  export: "Export",
  downloadCsv: "Download as CSV",
  print: "Print",
  noOrders: "No rows",
  noResults: "No results found.",
  rowsPerPage: "Rows per page:",
  selectedRows: "{{count}} row(s) selected",
  pageRange: "{{from}}–{{to}} of {{count}}",
};

translations.ar.resellerOrders = {
  selectDealer: "اختر الموزّع:",
  chooseDealer: "اختر موزّعاً",
  orderDate: "تاريخ الطلب:",
  productName: "اسم المنتج",
  serviceName: "اسم الخدمة",
  quantity: "الكمية",
  quantityLabel: "الكمية:",
  retailPrice: "سعر التجزئة",
  sellingPrice: "سعر البيع",
  totalPrice: "السعر الإجمالي",
  action: "الإجراء",
  actions: "الإجراءات",
  delete: "حذف",
  addProduct: "إضافة منتج",
  addService: "إضافة خدمة",
  totalAmount: "المبلغ الإجمالي:",
  submitOrder: "إرسال الطلب",
  addProductTitle: "إضافة منتج",
  chooseProduct: "اختر منتجاً",
  addServiceTitle: "إضافة خدمة",
  chooseService: "اختر خدمة",
  price: "السعر:",
  cancel: "إلغاء",
  add: "إضافة",
  orderSuccessful: "تم إنشاء الطلب بنجاح!",
  orderFailed: "فشل إنشاء الطلب!",
  invoiceId: "رقم الفاتورة",
  name: "الاسم",
  date: "التاريخ",
  show: "عرض",
  searchPlaceholder: "بحث...",
  invoiceDetails: "تفاصيل الفاتورة",
  close: "إغلاق",
  invoiceDetailsFor: "تفاصيل الفاتورة رقم {{id}}",
  itemType: "نوع العنصر",
  itemName: "اسم العنصر",
  product: "منتج",
  service: "خدمة",
  totalProductPrice: "إجمالي سعر المنتجات:",
  totalServicePrice: "إجمالي سعر الخدمات:",
  totalPriceLabel: "السعر الإجمالي:",
  detailsFetchError: "تعذّر تحميل تفاصيل الفاتورة. يرجى المحاولة مرة أخرى لاحقاً.",
  columns: "الأعمدة",
  filters: "عوامل التصفية",
  export: "تصدير",
  downloadCsv: "تنزيل بصيغة CSV",
  print: "طباعة",
  noOrders: "لا توجد طلبات",
  noResults: "لا توجد نتائج.",
  rowsPerPage: "عدد الصفوف في الصفحة:",
  selectedRows: "الصفوف المحددة: {{count}}",
  pageRange: "{{from}}–{{to}} من {{count}}",
};


/* NORMAL_ORDER_FORM_ARABIC_LOCALIZATION */
translations.ar.orderForm = {
  "submitting": "جارٍ الإرسال...",
  "selectClient": "اختر العميل:",
  "chooseClient": "اختر العميل",
  "orderDate": "تاريخ الطلب:",
  "newSubscriptionLabel": "اشتراك جديد:",
  "productName": "اسم المنتج",
  "serviceName": "اسم الخدمة",
  "quantity": "الكمية",
  "quantityLabel": "الكمية:",
  "sellingPrice": "سعر البيع",
  "totalPrice": "السعر الإجمالي",
  "isFree": "مجاني",
  "isFreeLabel": "مجاني:",
  "consumption": "الاستهلاك",
  "action": "الإجراء",
  "yes": "نعم",
  "no": "لا",
  "delete": "حذف",
  "addProduct": "إضافة منتج",
  "selectProduct": "اختر المنتج:",
  "addService": "إضافة خدمة",
  "selectService": "اختر الخدمة:",
  "cancel": "إلغاء",
  "add": "إضافة",
  "newSubscription": "اشتراك جديد",
  "newSubscriptionQuestion": "هل تريد إنشاء اشتراك جديد لهذه الخدمة؟",
  "serviceType": "نوع الخدمة:",
  "ossServiceType": "OSS (ألياف/لاسلكي)",
  "idmServiceType": "IDM (HSIPRO)",
  "priceLabel": "السعر:",
  "consumptionOption": "خيار الاستهلاك:",
  "selectOption": "اختر...",
  "limited": "محدود",
  "unlimited": "غير محدود",
  "idmUsername": "اسم مستخدم IDM:",
  "idmPassword": "كلمة مرور IDM:",
  "idmPlan": "باقة IDM:",
  "chooseIdmPlan": "اختر باقة IDM",
  "offer": "العرض",
  "viewOffers": "عرض العروض",
  "availableOffers": "العروض المتاحة",
  "close": "إغلاق",
  "subscriptionCreated": "تم إنشاء الاشتراك بنجاح",
  "username": "اسم المستخدم:",
  "password": "كلمة المرور:",
  "copyRequired": "⚠️ يجب نسخ بيانات الدخول قبل المتابعة.",
  "copyDone": "✅ تم نسخ بيانات الدخول! يمكنك الآن إغلاق هذه النافذة.",
  "copyCredentials": "نسخ بيانات الدخول",
  "closeFinish": "إغلاق وإنهاء",
  "submit": "إرسال",
  "selectSite": "اختر الموقع:",
  "selectWirelessAccessPoint": "اختر نقطة الوصول اللاسلكية:",
  "cpeMacAddress": "عنوان MAC لجهاز CPE:",
  "cpeMacPlaceholder": "أدخل عنوان MAC صالحاً لجهاز CPE",
  "hexOnly": "يُسمح فقط بالأرقام السداسية العشرية (0–9، A–F).",
  "selectCore": "اختر النواة:",
  "idmRequired": "يرجى إدخال اسم مستخدم IDM وكلمة المرور واختيار الباقة.",
  "orderSubscriptionSuccess": "تم إنشاء الطلب والاشتراك بنجاح!",
  "orderNoCredentials": "تم إنشاء الطلب، ولكن لم يتم إرجاع بيانات الدخول. يرجى التحقق من قائمة الطلبات.",
  "orderSuccess": "تم إنشاء الطلب بنجاح!",
  "orderFailed": "فشل إنشاء الطلب! يرجى المحاولة مرة أخرى.",
  "credentialsCopied": "تم نسخ بيانات الدخول إلى الحافظة!",
  "clipboardUnavailable": "الحافظة غير متاحة في هذا المتصفح."
};


/* NORMAL_ORDER_LIST_ARABIC_LOCALIZATION */
translations.ar.orderList = {
  "status": "الحالة",
  "initiator": "المنشئ",
  "details": "التفاصيل",
  "quotation": "عرض سعر",
  "invoice": "فاتورة",
  "update": "تعديل",
  "cancel": "إلغاء",
  "pending": "قيد الانتظار",
  "confirmed": "مؤكد",
  "cancelled": "ملغى",
  "quotationFor": "عرض سعر للعميل {{name}}",
  "invoiceFor": "فاتورة للعميل {{name}}",
  "cancelConfirm": "هل أنت متأكد أنك تريد إلغاء هذا الطلب؟",
  "cancelSuccess": "تم إلغاء الطلب بنجاح",
  "cancelFailed": "تعذّر إلغاء الطلب",
  "cancelBlocked": "تعذّر إلغاء الطلب: الجهاز المرتجع لم يعد موجوداً في المستودع.",
  "cancelNeedsEmployee": "تعذّر إلغاء الطلب: يلزم ملف موظف لإخراج الجهاز المرتجع من المستودع.",
  "cancelInvoicePaid": "تعذّر إلغاء الطلب: فاتورة هذا الطلب عليها دفعة. ألغِ الإيصال أولاً، ثم الفاتورة، ثم الطلب."
};


/* NORMAL_ORDER_INVOICE_ARABIC_LOCALIZATION */
translations.ar.orderInvoice = {
  "username": "اسم المستخدم:",
  "chooseUsername": "اختر اسم المستخدم",
  "selectWarehouseLabel": "اختر المستودع:",
  "selectWarehouse": "اختر المستودع",
  "selectDrawerLabel": "اختر الصندوق:",
  "selectDrawer": "اختر الصندوق",
  "note": "ملاحظة:",
  "description": "الوصف:",
  "itemType": "نوع العنصر",
  "itemName": "اسم العنصر",
  "quantity": "الكمية",
  "unitPrice": "سعر الوحدة",
  "totalPrice": "السعر الإجمالي",
  "isFree": "مجاني",
  "product": "منتج",
  "service": "خدمة",
  "yes": "نعم",
  "no": "لا",
  "total": "الإجمالي:",
  "totalWithoutDiscount": "الإجمالي قبل الخصم:",
  "discount": "الخصم:",
  "totalWithDiscount": "الإجمالي بعد الخصم:",
  "createInvoice": "إنشاء فاتورة",
  "creationSuccessful": "تم إنشاء الفاتورة بنجاح!",
  "creationFailed": "فشل إنشاء الفاتورة!",
  "shiftRequired": "يجب فتح وردية لإنشاء فاتورة."
};


/* NORMAL_INVOICE_LIST_ARABIC_LOCALIZATION */
translations.ar.invoiceList = {
  "id": "الرقم",
  "status": "الحالة",
  "name": "الاسم",
  "date": "التاريخ",
  "total": "الإجمالي",
  "discount": "الخصم",
  "totalMinusDiscount": "الإجمالي بعد الخصم",
  "note": "ملاحظة",
  "initiator": "المنشئ",
  "actions": "الإجراءات",
  "pending": "قيد الانتظار",
  "settled": "مسددة",
  "unsettled": "غير مسددة",
  "cancelled": "ملغاة",
  "done": "منجز",
  "blocked": "محظور",
  "details": "التفاصيل",
  "edit": "تعديل",
  "print": "طباعة",
  "cancel": "إلغاء",
  "editInvoice": "تعديل الفاتورة",
  "onlyPendingEditable": "يمكن تعديل الفواتير المعلقة فقط",
  "search": "بحث...",
  "filter": "عوامل التصفية",
  "excel": "إكسل",
  "statusChanged": "تم تغيير الحالة!",
  "editFailed": "فشل التعديل!",
  "cancelReceiptFirst": "تعذّر إلغاء الفاتورة: عليها إيصال. ألغِ الإيصال أولاً، ثم الفاتورة.",
  "cancelDeviceMissing": "تعذّر إلغاء الفاتورة: الجهاز المرتجع لم يعد موجوداً في المستودع.",
  "cancelFailed": "تعذّر إلغاء الفاتورة. حاول مرة أخرى."
};

translations.ar.fiberCores = {
  "zone": "المنطقة:",
  "selectZone": "اختر المنطقة",
  "codeRequired": "رمز الكور مطلوب.",
  "codeExists": "هذا الكور موجود مسبقاً.",
  "zoneNotFound": "المنطقة المختارة غير موجودة.",
  "addFailed": "فشلت الإضافة!"
};

/* CLIENTS_PAGE_ARABIC_LOCALIZATION */
translations.en.clientsPage = {
  addClient: "Add Client",
  allClients: "All Clients",
  withoutMiddleName: "Clients Without Middle Name",
  search: "Search...",
  searchWithoutMiddleName: "Search Clients Without Middle Name...",
  filter: "Filter",
  excel: "Excel",
  filtersTitle: "Filters",
  filterBy: "Filter by {{column}}",
  close: "Close",
  editClient: "Edit Client",
  edit: "Edit",
  clientUpdated: "Client updated successfully.",
  excelFileName: "Clients.xlsx",
  excelSheet: "Clients",
  columns: {
    fullName: "Full Name",
    phoneNumber: "Phone Number",
    villageName: "Village Name",
    category: "Category",
    address: "Address",
    actions: "Actions",
  },
  categories: {
    "-": "-",
    NMC: "NMC",
    MC: "MC",
    Standard: "Standard",
    Special: "Special",
    VIP: "VIP",
    Blacklist: "Blacklist",
  },
  grid: {
    toolbarColumns: "Columns",
    toolbarFilters: "Filters",
    toolbarExport: "Export",
    toolbarExportCSV: "Download as CSV",
    toolbarExportPrint: "Print",
    columnsPanelTextFieldLabel: "Find column",
    columnsPanelTextFieldPlaceholder: "Column title",
    columnsPanelDragIconLabel: "Reorder column",
    columnsPanelShowAllButton: "Show all",
    columnsPanelHideAllButton: "Hide all",
    filterPanelAddFilter: "Add filter",
    filterPanelDeleteIconLabel: "Delete",
    filterPanelOperators: "Operator",
    filterPanelOperatorAnd: "And",
    filterPanelOperatorOr: "Or",
    filterPanelColumns: "Columns",
    filterPanelInputLabel: "Value",
    filterPanelInputPlaceholder: "Filter value",
    filterOperatorContains: "contains",
    filterOperatorEquals: "equals",
    filterOperatorStartsWith: "starts with",
    filterOperatorEndsWith: "ends with",
    filterOperatorIsEmpty: "is empty",
    filterOperatorIsNotEmpty: "is not empty",
    filterOperatorIsAnyOf: "is any of",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Show columns",
    columnMenuFilter: "Filter",
    columnMenuHideColumn: "Hide",
    columnMenuUnsort: "Unsort",
    columnMenuSortAsc: "Sort by ASC",
    columnMenuSortDesc: "Sort by DESC",
    noRowsLabel: "No rows",
    noResultsOverlayLabel: "No results found.",
    footerTotalRows: "Total Rows:",
    rowsPerPage: "Rows per page:",
    pageRange: "{{from}}-{{to}} of {{count}}",
  },
};

translations.ar.clientsPage = {
  addClient: "\u0625\u0636\u0627\u0641\u0629 \u0639\u0645\u064a\u0644",
  allClients: "\u0643\u0644 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
  withoutMiddleName: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0628\u062f\u0648\u0646 \u0627\u0633\u0645 \u0627\u0644\u0623\u0628",
  search: "\u0628\u062d\u062b...",
  searchWithoutMiddleName: "\u0627\u0644\u0628\u062d\u062b \u0641\u064a \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0628\u062f\u0648\u0646 \u0627\u0633\u0645 \u0627\u0644\u0623\u0628...",
  filter: "\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062a\u0635\u0641\u064a\u0629",
  excel: "\u0625\u0643\u0633\u0644",
  filtersTitle: "\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062a\u0635\u0641\u064a\u0629",
  filterBy: "\u062a\u0635\u0641\u064a\u0629 \u062d\u0633\u0628 {{column}}",
  close: "\u0625\u063a\u0644\u0627\u0642",
  editClient: "\u062a\u0639\u062f\u064a\u0644 \u0639\u0645\u064a\u0644",
  edit: "\u062a\u0639\u062f\u064a\u0644",
  clientUpdated: "\u062a\u0645 \u062a\u062d\u062f\u064a\u062b \u0627\u0644\u0639\u0645\u064a\u0644 \u0628\u0646\u062c\u0627\u062d.",
  excelFileName: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621.xlsx",
  excelSheet: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621",
  columns: {
    fullName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
    phoneNumber: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641",
    villageName: "\u0627\u0633\u0645 \u0627\u0644\u0628\u0644\u062f\u0629",
    category: "\u0627\u0644\u0641\u0626\u0629",
    address: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    actions: "\u0627\u0644\u0625\u062c\u0631\u0627\u0621\u0627\u062a",
  },
  categories: {
    "-": "-",
    NMC: "\u0625\u0646 \u0625\u0645 \u0633\u064a",
    MC: "\u0625\u0645 \u0633\u064a",
    Standard: "\u0639\u0627\u062f\u064a",
    Special: "\u0645\u0645\u064a\u0632",
    VIP: "\u0641\u064a \u0622\u064a \u0628\u064a",
    Blacklist: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0633\u0648\u062f\u0627\u0621",
  },
  grid: {
    toolbarColumns: "\u0627\u0644\u0623\u0639\u0645\u062f\u0629",
    toolbarFilters: "\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062a\u0635\u0641\u064a\u0629",
    toolbarExport: "\u062a\u0635\u062f\u064a\u0631",
    toolbarExportCSV: "\u062a\u0646\u0632\u064a\u0644 \u0643\u0645\u0644\u0641 CSV",
    toolbarExportPrint: "\u0637\u0628\u0627\u0639\u0629",
    columnsPanelTextFieldLabel: "\u0627\u0628\u062d\u062b \u0639\u0646 \u0639\u0645\u0648\u062f",
    columnsPanelTextFieldPlaceholder: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0639\u0645\u0648\u062f",
    columnsPanelDragIconLabel: "\u0625\u0639\u0627\u062f\u0629 \u062a\u0631\u062a\u064a\u0628 \u0627\u0644\u0639\u0645\u0648\u062f",
    columnsPanelShowAllButton: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0643\u0644",
    columnsPanelHideAllButton: "\u0625\u062e\u0641\u0627\u0621 \u0627\u0644\u0643\u0644",
    filterPanelAddFilter: "\u0625\u0636\u0627\u0641\u0629 \u0639\u0627\u0645\u0644 \u062a\u0635\u0641\u064a\u0629",
    filterPanelDeleteIconLabel: "\u062d\u0630\u0641",
    filterPanelOperators: "\u0627\u0644\u0639\u0627\u0645\u0644",
    filterPanelOperatorAnd: "\u0648",
    filterPanelOperatorOr: "\u0623\u0648",
    filterPanelColumns: "\u0627\u0644\u0623\u0639\u0645\u062f\u0629",
    filterPanelInputLabel: "\u0627\u0644\u0642\u064a\u0645\u0629",
    filterPanelInputPlaceholder: "\u0642\u064a\u0645\u0629 \u0627\u0644\u062a\u0635\u0641\u064a\u0629",
    filterOperatorContains: "\u064a\u062d\u062a\u0648\u064a \u0639\u0644\u0649",
    filterOperatorEquals: "\u064a\u0633\u0627\u0648\u064a",
    filterOperatorStartsWith: "\u064a\u0628\u062f\u0623 \u0628\u0640",
    filterOperatorEndsWith: "\u064a\u0646\u062a\u0647\u064a \u0628\u0640",
    filterOperatorIsEmpty: "\u0641\u0627\u0631\u063a",
    filterOperatorIsNotEmpty: "\u063a\u064a\u0631 \u0641\u0627\u0631\u063a",
    filterOperatorIsAnyOf: "\u0623\u064a \u0645\u0646",
    columnMenuLabel: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
    columnMenuShowColumns: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0623\u0639\u0645\u062f\u0629",
    columnMenuFilter: "\u062a\u0635\u0641\u064a\u0629",
    columnMenuHideColumn: "\u0625\u062e\u0641\u0627\u0621",
    columnMenuUnsort: "\u0625\u0644\u063a\u0627\u0621 \u0627\u0644\u062a\u0631\u062a\u064a\u0628",
    columnMenuSortAsc: "\u062a\u0631\u062a\u064a\u0628 \u062a\u0635\u0627\u0639\u062f\u064a",
    columnMenuSortDesc: "\u062a\u0631\u062a\u064a\u0628 \u062a\u0646\u0627\u0632\u0644\u064a",
    noRowsLabel: "\u0644\u0627 \u062a\u0648\u062c\u062f \u0628\u064a\u0627\u0646\u0627\u062a",
    noResultsOverlayLabel: "\u0644\u0627 \u062a\u0648\u062c\u062f \u0646\u062a\u0627\u0626\u062c",
    footerTotalRows: "\u0625\u062c\u0645\u0627\u0644\u064a \u0627\u0644\u0635\u0641\u0648\u0641:",
    rowsPerPage: "\u0639\u062f\u062f \u0627\u0644\u0635\u0641\u0648\u0641 \u0641\u064a \u0627\u0644\u0635\u0641\u062d\u0629:",
    pageRange: "{{from}}-{{to}} \u0645\u0646 {{count}}",
  },
};

/* CLIENT_FORM_ARABIC_LOCALIZATION */
translations.en.clientForm = {
  firstName: "First Name (EN):",
  middleName: "Middle Name (EN):",
  lastName: "Last Name (EN):",
  firstNameAr: "First Name (AR):",
  middleNameAr: "Middle Name (AR):",
  lastNameAr: "Last Name (AR):",
  phone: "Phone:",
  village: "Village:",
  address: "Address:",
  collector: "Collector:",
  category: "Category:",
  tempCollection: "Temp Collection:",
  tempCollectionOffice: "Temp Collection Office:",
  potentialClient: "Potential Client:",
  freeCollection: "Free Collection:",
  phFirstName: "First Name (EN)",
  phMiddleName: "Middle Name (EN)",
  phLastName: "Last Name (EN)",
  phFirstNameAr: "First Name (AR)",
  phMiddleNameAr: "Middle Name (AR)",
  phLastNameAr: "Last Name (AR)",
  phPhone: "phone",
  phVillage: "Choose Village",
  phAddress: "Address",
  phSelect: "Select...",
  create: "Create",
};

translations.ar.clientForm = {
  firstName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 (\u0625\u0646\u0643\u0644\u064a\u0632\u064a):",
  middleName: "\u0627\u0633\u0645 \u0627\u0644\u0623\u0628 (\u0625\u0646\u0643\u0644\u064a\u0632\u064a):",
  lastName: "\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629 (\u0625\u0646\u0643\u0644\u064a\u0632\u064a):",
  firstNameAr: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 (\u0639\u0631\u0628\u064a):",
  middleNameAr: "\u0627\u0633\u0645 \u0627\u0644\u0623\u0628 (\u0639\u0631\u0628\u064a):",
  lastNameAr: "\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629 (\u0639\u0631\u0628\u064a):",
  phone: "\u0627\u0644\u0647\u0627\u062a\u0641:",
  village: "\u0627\u0644\u0628\u0644\u062f\u0629:",
  address: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646:",
  collector: "\u0627\u0644\u0645\u062d\u0635\u0651\u0644:",
  category: "\u0627\u0644\u0641\u0626\u0629:",
  tempCollection: "\u062a\u062d\u0635\u064a\u0644 \u0645\u0624\u0642\u062a:",
  tempCollectionOffice: "\u062a\u062d\u0635\u064a\u0644 \u0645\u0624\u0642\u062a \u0645\u0646 \u0627\u0644\u0645\u0643\u062a\u0628:",
  potentialClient: "\u0639\u0645\u064a\u0644 \u0645\u062d\u062a\u0645\u0644:",
  freeCollection: "\u062a\u062d\u0635\u064a\u0644 \u0645\u062c\u0627\u0646\u064a:",
  phFirstName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 (\u0625\u0646\u0643\u0644\u064a\u0632\u064a)",
  phMiddleName: "\u0627\u0633\u0645 \u0627\u0644\u0623\u0628 (\u0625\u0646\u0643\u0644\u064a\u0632\u064a)",
  phLastName: "\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629 (\u0625\u0646\u0643\u0644\u064a\u0632\u064a)",
  phFirstNameAr: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 (\u0639\u0631\u0628\u064a)",
  phMiddleNameAr: "\u0627\u0633\u0645 \u0627\u0644\u0623\u0628 (\u0639\u0631\u0628\u064a)",
  phLastNameAr: "\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629 (\u0639\u0631\u0628\u064a)",
  phPhone: "\u0627\u0644\u0647\u0627\u062a\u0641",
  phVillage: "\u0627\u062e\u062a\u0631 \u0627\u0644\u0628\u0644\u062f\u0629",
  phAddress: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
  phSelect: "\u0627\u062e\u062a\u0631...",
  create: "\u0625\u0646\u0634\u0627\u0621",
};

/* COLLECTION_REQUESTS_PAGE */
translations.en.sidebar = {
  ...(translations.en.sidebar || {}),
  collectionRequests: "Collection Requests",
};
translations.ar.sidebar = {
  ...(translations.ar.sidebar || {}),
  collectionRequests: "طلبات التحصيل",
};
translations.en.collectionRequests = {
  title: "Collection Requests",
  collector: "Collector",
  allCollectors: "All collectors",
  status: "Status",
  statusPending: "Pending",
  statusAccepted: "Accepted",
  statusRefused: "Refused",
  statusAll: "All",
  enabled: "Free Collection enabled for this collector",
  requestsRemove: "requests to remove the ${{amount}} collection fee for",
  invoice: "Invoice #{{id}}",
  requestedBy: "Requested by",
  decidedBy: "Decided by",
  accept: "Accept",
  refuse: "Refuse",
  processing: "Processing...",
  loading: "Loading...",
  empty: "No requests.",
  loadFailed: "Could not load requests.",
  actionFailed: "The request could not be processed.",
};
translations.ar.collectionRequests = {
  title: "طلبات التحصيل",
  collector: "المحصّل",
  allCollectors: "كل المحصّلين",
  status: "الحالة",
  statusPending: "قيد الانتظار",
  statusAccepted: "مقبول",
  statusRefused: "مرفوض",
  statusAll: "الكل",
  enabled: "التحصيل المجاني مفعّل لهذا المحصّل",
  requestsRemove: "يطلب إزالة رسم التحصيل ${{amount}} عن",
  invoice: "الفاتورة رقم {{id}}",
  requestedBy: "طلب بواسطة",
  decidedBy: "القرار بواسطة",
  accept: "قبول",
  refuse: "رفض",
  processing: "جارٍ المعالجة...",
  loading: "جارٍ التحميل...",
  empty: "لا توجد طلبات.",
  loadFailed: "تعذّر تحميل الطلبات.",
  actionFailed: "تعذّر تنفيذ الطلب.",
};

export default translations;
